import React, { useEffect, useState, useContext } from 'react'
import MapContext from './MapContext'
import NordIcon from '../../icons/nord.svg'

const BearingControl = (props) => {
  const map = useContext(MapContext)
  const [bearing, setBaering] = useState((map) ? map.getBearing() : 0)

  useEffect(() => {
    if (!map) return

    const mapChangeHandler = () => {
      setBaering(map.getBearing())
    }
    map.on('rotate', mapChangeHandler)
    mapChangeHandler()

    return () => {
      if (map && map.off) {
        map.off('rotate', mapChangeHandler)
      }
    }
  }, [map])

  return (
    <button className="button basic circular bearing fa"
            style={{ transform: `rotate(${-bearing}deg)` }}
            onClick={(e) => map.easeTo({bearing: 0}, {originalEvent: e})}>
        <NordIcon/>
    </button>
  )
}

export default BearingControl
